import { Component } from '@angular/core';
import { ReportShareComponent } from '../../report-share.component';

@Component({
  selector: 'app-coachee-least-style',
  templateUrl: './coachee-least-style.component.html'
})
export class CoacheeLeastStyleComponent extends ReportShareComponent {

  get html(): string {
    return this.report?.leastDevCoachingStyleDesc?.replaceAll("\n","<br />") ?? ''
  }

}
